module.exports = __webpack_public_path__ + "img/brush-gold.68ad67e0.png";